import { lightRadiusAdmin } from '../figmaTokens/Admin';
export const radius = Object.assign({}, lightRadiusAdmin);
